<template>
  <div class="pro-inside" v-loading="loading">
    <div class="crumbs">
      <p>
        <a href="/home" target="">首页</a> /
        <a @click="handleSecondClick(parentId)" target="">{{parentName}}</a> /
        <a href="" target="">{{childrenName}}</a>
      </p>
    </div>
    <div class="container">
      <div class="player-list">
        <div v-for="(item, index) in productList" :key="index" class="product-card">
          <div class="product-item" @click="handleProductClick(item.id)">
            <div class="product-img-wrap">
              <img :src="item.url+item.thumbnailSrc" alt="">
            </div>
            <div class="product-desc">
              <h3 class="nowrap">{{item.name}}</h3>
              <span class="desc-text">{{item.description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductClassifyById } from "@/api/home";

export default {
  data() {
    return {
      loading: false,
      title: '',
      description: '',
      mainPicSrc: '',
      productList: [],
      parentId: '',
      parentName: '',
      childrenId: '',
      childrenName: '',
    }
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newQuery) {
        const { parentId, childrenId } = newQuery;
        if (!parentId) {
          this.$message.warning("父级ID不能为空");
          return;
        }
        if (!childrenId) {
          this.$message.warning("子级ID不能为空");
          return;
        }
        this.parentId = parentId;
        this.childrenId = childrenId;
        this.parseChildProducts(parentId, childrenId);
      }
    }
  },
  methods: {
    handleSecondClick(parentId) {
      this.$router.push({
        path: "/brand_cl",
        query: {
          productId: parentId
        }
      });
    },
    handleProductClick(id) {
      this.$router.push({
        path: "/fourth_cl",
        query: {
          productId: id,
          parentId: this.parentId + "-" + this.childrenId,
          parentName: this.childrenName
        }
      });
    },
    async parseChildProducts(parentId, childrenId) {
      try {
        this.loading = true;
        const res = await getProductClassifyById(parentId);
        if (res.code === 200) {
          const data = res.data[0];
          this.parentName = data.name;
          const targetItem = data.children.find(item => item.id == childrenId)
          if (targetItem) {
            this.childrenName = targetItem.name;
            this.productList = targetItem.children || [];
          }
        } else {
          this.$message.error(res.msg || "获取产品详情失败");
        }
      } catch (error) {
        console.error("产品详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pro-inside {
  margin-top: 100px;
  width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin-top: 50px;
  }
}

.crumbs {
  bottom: 38px;
  left: 9%;
  padding: 20px 40px;
  background: rgba(255, 255, 255, .7);
  width: 100%;

  @media (max-width: 768px) {
    padding: 10px 15px;
    left: 0;
    bottom: 0;
  }

  p {
    color: #999;
    font-size: 12px;
    line-height: 20px;

    @media (max-width: 768px) {
      font-size: 11px;
    }
  }

  p a {
    display: inline-block;
    vertical-align: top;
    margin: 0 10px;
    color: #666;
    text-decoration: none;

    @media (max-width: 768px) {
      margin: 0 5px;
    }
  }

  p a:first-child {
    margin-left: 0;
  }

  p a:hover {
    color: #000;
  }

  h2 {
    font-size: 30px;
    color: #555;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
}

.container {
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 10px;
    max-width: 100%;
  }
}

.player-list {
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 5%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .product-card {
    width: 385px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    gap: 10px;
    justify-content: space-between;

    .product-card {
      width: calc(50% - 5px);
      max-width: 165px;
      margin-bottom: 15px;
    }
  }
}

.product-item {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background: #fff;

  .product-img-wrap {
    width: 100%;
    height: 385px;
    overflow: hidden;
    position: relative;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      border: none;
    }

    &::after {
      content: '';
      position: absolute;
      left: 15%;
      bottom: 0;
      z-index: 2;
      border: 10px solid transparent;
      border-bottom-color: #a8a8a8;
    }

    @media (max-width: 768px) {
      height: 165px;

      &::after {
        border-width: 6px;
      }
    }
  }

  .product-desc {
    width: 100%;
    padding: 15px 10px;
    background: #a8a8a8;
    position: static;
    z-index: 0;

    @media (max-width: 768px) {
      padding: 8px 5px;
    }

    &::before {
      display: none;
    }

    h3 {
      padding-bottom: 8px;
      font-size: 16px;
      border-bottom: 1px dotted #333;
      margin: 0;
      color: #333;

      @media (max-width: 768px) {
        font-size: 12px;
        padding-bottom: 4px;
      }
    }

    // 核心修改：调大高度 + 多行省略
    .desc-text {
      display: -webkit-box; // 必须：配合line-clamp
      -webkit-box-orient: vertical; // 必须：垂直排列
      -webkit-line-clamp: 4; // 关键：最多显示4行，超过则省略（可根据需要调整）
      max-height: 80px; // 调大：PC端最大高度80px（原40px，翻倍）
      margin-top: 8px;
      line-height: 20px; // 行高20px，80px刚好4行，和line-clamp对应
      overflow: hidden; // 必须：隐藏超出部分
      text-overflow: ellipsis; // 必须：显示省略号
      color: #333;
      font-size: 14px;
      word-break: break-all; // 防止长单词溢出

      // 移动端：调大高度 + 多行省略
      @media (max-width: 768px) {
        -webkit-line-clamp: 8; // 移动端同样最多4行
        max-height: 120px; // 调大：移动端最大高度60px（原30px，翻倍）
        line-height: 15px; // 行高15px，60px刚好4行
        font-size: 10px;
        margin-top: 4px;
      }
    }
  }
}
</style>